<div class="overlay" *ngIf="isVisible" [@fadeInOut]>
    <div class="popup">
    	<h1 class="title">{{title | translate | capitalizeFirst}}</h1>
    	<a class="close" (click)="isVisible = false; resetConfirmation()" [class.hide]="hideX">&times;</a>
        <ng-container *ngIf="confirmSelection; else noConfirmSelection">
            <div style="padding-top: 15px;">
                {{'R_U_SURE_TO_DELETE' | translate | capitalizeFirst}}
                <div>
                    <button type="button" style="float: left" (click)="deleteFeedback(false)">{{'NO' | translate}}</button>
                    <button type="button" style="float: right" (click)="deleteFeedback()">{{'YES' | translate}}</button>
                </div>
            </div>
        </ng-container>
        <ng-template #noConfirmSelection>
            <div class="content" [innerHTML]="description | translate:params | capitalizeFirst" *ngIf="description">
            </div>
            <div style="padding-top: 15px;">
                <div class="container__docs" *ngFor="let doc of getSortedDocList(listaDocs)">
                    <div class="row__docs">
                        <div (click)="clickOnDoc(doc)" style="cursor:pointer;">
                            <img class="doc__img" src="./assets/img/magnifier.svg" alt="Preview" height="20" style="vertical-align: middle; margin-right: 1em;">
                            <span class="doc__text">{{'PAGE' |translate |capitalizeFirst}} {{doc.numeroPagina}}</span>
                        </div>
                        <img class="doc__img" (click)="deleteButtonClick(doc)" src="./assets/img/delete-button.png" alt="delete" height="20">
                    </div>
                </div>
            </div>
        </ng-template>
        <div *ngIf="textButton">
        	<button type="button" style="float: right; margin-right: 0" (click)="textButtonClick()">{{textButton | translate}}</button>
        </div>
    </div>
</div>